export interface FuelCellSample {
  data: number;
  dateTime: string | Date;
}

export interface FuelCellRow {
  id: string;
  name: string;
  licensePlate: string;
  vin: string;
  serialNumber: string;
  tankCapacityKg: number | null;
  levelPercent: number | null;
  remainingKg: number | null;
  usedKg: number | null;
  updatedAt: Date | null;
  /** The vehicle drove without reporting its tank level, so the tank figures cannot be trusted. */
  isStale: boolean;
  usedRangeKg: number | null;
  refillCount: number | null;
  distanceKm: number | null;
  avgConsumptionKgPer100Km: number | null;
}

export interface FuelCellSummaryStats {
  totalUsedKg: number;
  totalRefills: number;
  avgLevelPercent: number | null;
  lowFuelCount: number;
  deviceCount: number;
}

export const LOW_FUEL_THRESHOLD_PERCENT = 20;
